module.exports = __webpack_public_path__ + "img/register-down.0bacd536.png";